import ExamSkeletonLoader from "@/components/common/examLoader"
import { capitalizeFirstLetter } from "@/utils"

import PreviousBtn from "@/assets/svg/previousBtn.svg";
import NextBtn from "@/assets/icons/nextBtn.png";
import "./style.css"
import "@/pages/exam/style.css"
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

export default function ExamResultMainView(props: any) {
    const {
        isLoading,
        resultDetails,
        attempts,
        getBackGroundColorForOption,
        rightAnsWrongAnsIcon,
        currentPage,
        onPageChange,
        totalPages
    } = props
    const { bottomSafeComponent } = useSafeAreaInsets();
    return (
        <>
            <div className="min-h-screen examMainViewCon0">
                <div className="examPageMainContainer">

                    {isLoading ? (
                        <ExamSkeletonLoader />
                    ) : (
                        <>
                            {/* ----------- START d2 */}
                            <div className="examPageHeadingContainer">
                                <hr style={{ margin: "15px 0px 10px 0px" }} />

                                <div className="examPageHeadingContainer_result0">
                                    <p className="heading">Attempted</p>
                                    <div className="examPageHeadingContainer_result0_1">
                                        {resultDetails.outOff}{'/'}{resultDetails.totalAttempts}
                                    </div>
                                </div>

                                <div className="examPageHeadingContainer_result0">
                                    <p className="heading">Percentage</p>
                                    <div className="examPageHeadingContainer_result0_1">
                                        {resultDetails.percentage}%
                                    </div>
                                </div>


                                <div className="examPageHeadingContainer_result0">
                                    <p className="heading">Status</p>
                                    <div
                                        style={{
                                            backgroundColor: resultDetails.result === "failed" ? "#f90000" : "#4D80CD"
                                        }}
                                        className="examPageHeadingContainer_result0_1">
                                        {capitalizeFirstLetter(resultDetails.result)}
                                    </div>
                                </div>
                            </div>
                            {/* ----------- END d1 */}

                            <p className="certificateNoteCon">
                                Your results will expire when the certificate is delivered.
                            </p>



                            {/* ----------- START d2 */}
                            {attempts
                                && attempts.length > 0 &&
                                <div className="questionMainCon">
                                    {attempts.map((questionData: any, questionDataIndex: any) => (
                                        <div key={questionDataIndex}>
                                            {questionData.selectedOption !== null &&
                                                <div
                                                    className="singleQuestionCon singleQuestionCon_result">
                                                    <p className="questionTitle">
                                                        {questionData.question}
                                                    </p>
                                                    {questionData.thumbnailUrl && (
                                                        <center>
                                                            <img
                                                                className="questionsThumbnailUrl"
                                                                src={questionData.thumbnailUrl}
                                                                alt="thumbnailUrl"
                                                            />
                                                        </center>
                                                    )}

                                                    {questionData.options.map((option: any, optionIndex: any) => (
                                                        <div
                                                            style={{ backgroundColor: getBackGroundColorForOption(questionData, option) }}
                                                            className="questionOptionCon questionOptionCon_result"
                                                            key={optionIndex}>

                                                            <div>
                                                                <input
                                                                    className="appearance-none w-4 h-4 border-1 border-gray-400 rounded-full checked:bg-black checked:border-black"
                                                                    disabled
                                                                    name={"radio_" + questionDataIndex}
                                                                    id={
                                                                        questionDataIndex +
                                                                        "_" +
                                                                        optionIndex
                                                                    }
                                                                    checked={
                                                                        questionData.selectedOption ===
                                                                            option
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    type="radio" />
                                                                <label
                                                                    htmlFor={
                                                                        questionDataIndex +
                                                                        "_" +
                                                                        optionIndex
                                                                    }>
                                                                    {option}
                                                                </label>

                                                            </div>
                                                            {rightAnsWrongAnsIcon(questionData, option) !== null &&
                                                                <img
                                                                    alt="rightAnsWrongAnsIcon"
                                                                    className="rightAnsWrongAnsIcon"
                                                                    src={rightAnsWrongAnsIcon(questionData, option)} />
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                    ))}
                                </div>
                            }
                            {/* ----------- END d2 */}



                            {/* ----------- START Pagination controls */}
                            {attempts && attempts.length > 0 &&

                                <div className="pageNavigationBtn">
                                    <img
                                        style={{
                                            visibility: currentPage === 1
                                                ? "hidden"
                                                : "visible",
                                        }}
                                        onClick={() => onPageChange(currentPage - 1)}
                                        src={PreviousBtn}
                                        alt="PreviousBtn"
                                    />


                                    {currentPage !== totalPages ? (
                                        <>
                                            <img
                                                onClick={() => onPageChange(currentPage + 1)}
                                                src={NextBtn}
                                                alt="NextBtn"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            {/* <div className="submitExamContainer">
                                                <p>Please attempt all the questions*</p>
                                                <button
                                                    style={{
                                                        cursor: examSubmitBtnIsLoading ? 'not-allowed' : 'cursor',
                                                        opacity: examSubmitBtnIsLoading ? '0.7' : '1',
                                                    }}
                                                    disabled={examSubmitBtnIsLoading}
                                                    onClick={handleExamSubmit}>
                                                    Submit
                                                </button>
                                            </div> */}
                                        </>
                                    )}
                                </div>
                            }
                            {/* ----------- END Pagination controls */}                            
                        </>
                    )
                    }
                </div>
                {bottomSafeComponent}
            </div>
        </>
    )
}